import React, { useRef, useState } from 'react';
import { TextField, ListItemText, Button, Checkbox, Select, MenuItem, FormControl, InputLabel, Snackbar, Alert } from '@mui/material';
import emailjs from '@emailjs/browser';
import '../static/App.css';

const HomeCareForm = () => {
    const form = useRef();

    const [contactMethod, setContactMethod] = useState('');
    const [lookingFor, setLookingFor] = useState('');
    const [hearAboutUs, setHearAboutUs] = useState('');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [daysNeeded, setDaysNeeded] = useState([]);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const servID = process.env.REACT_APP_SERVID;
    const tempID = process.env.REACT_APP_TEMPID;
    const uid = process.env.REACT_APP_UID;

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(servID, tempID, form.current, uid)
            .then((result) => {
                console.log(result.text);
                setEmail('');
                setHearAboutUs('');
                setContactMethod('');
                setLookingFor('');
                setDaysNeeded([]);
                setOpenSnackbar(true);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const handleContactMethodChange = (event) => {
        setContactMethod(event.target.value);
    };
    const handleLookingForChange = (event) => {
        setLookingFor(event.target.value);
    };
    const handleHearAboutUsChange = (event) => {
        setHearAboutUs(event.target.value);
    };
    const handleDaysNeededChange = (event) => {
        setDaysNeeded(event.target.value);
    };
    const handleEmailChange = (event) => {
        const value = event.target.value;
        setEmail(value);
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(value)) {
            setEmailError('Invalid email address');
        } else {
            setEmailError('');
        }
    };

    return (
        <div className='mbr-form p-3' style={{ height: '647px'}}>
            <p className='text-center h4 mb-3'>In Need Of Our Services?</p>
            <form ref={form} onSubmit={sendEmail}>
                <input type="hidden" value="Home Care Services" name='subject' />
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <TextField size="small" label="Full Name" color="primary" type="text" required name="name" fullWidth />
                    </div>
                    <div className="col-md-6 mb-2">
                        <TextField size="small" label="Phone Number" color="primary" type="tel" required name="phoneNumber" fullWidth />
                    </div>
                    
                </div>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <TextField size="small" label="Email" color="primary" type="email" name="email" fullWidth 
                            value={email} onChange={handleEmailChange} error={!!emailError} helperText={emailError}/>
                    </div>
                    <div className="col-md-6 mb-2">
                        <FormControl fullWidth size="small">
                            <InputLabel color="primary" required id="contactMethodLabel">Preferred Contact Method</InputLabel>
                            <Select value={contactMethod} onChange={handleContactMethodChange} required color="primary" 
                                    labelId="contactMethodLabel" label="Preferred Contact Method" name="contactMethod">
                                <MenuItem value="phone">Phone</MenuItem>
                                <MenuItem value="email">Email</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-md-6 mb-2">
                        <FormControl fullWidth size="small">
                            <InputLabel color="primary" id="hearAboutUsLabel">How Did You Hear About Us</InputLabel>
                            <Select value={hearAboutUs} onChange={handleHearAboutUsChange}
                                color="primary" labelId="hearAboutUsLabel" label="How Did You Hear About Us" name="hearAboutUs">
                                <MenuItem value="Friend/Family">Friend/Family</MenuItem>
                                <MenuItem value="Google">Google</MenuItem>
                                <MenuItem value="DoctorNurse">Doctor/Nurse</MenuItem>
                                <MenuItem value="Advertisement">Advertisement</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-md-6 mb-2">
                        <FormControl fullWidth size="small">
                            <InputLabel color="primary" required id="lookingForLabel">I Am Looking For</InputLabel>
                            <Select value={lookingFor} onChange={handleLookingForChange} color="primary" required 
                                labelId="lookingForLabel" label="I Am Looking For" name="lookingFor">
                                <MenuItem value="24hr-LiveIn">24hr Live-in</MenuItem>
                                <MenuItem value="Hourly">Hourly</MenuItem>
                                <MenuItem value="Respite-Care">Respite Care</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <TextField size="small" label="Age of Client" color="primary" type="number" required name="ageOfClient" fullWidth />
                    </div>
                    <div className="col-md-6 mb-2">
                        <TextField size="small" label="Area Zipcode" color="primary" type="number" required name="zipcode" fullWidth />
                    </div>
                    <div className="col-md-6 mb-2">
                        <FormControl fullWidth size="small">
                            <InputLabel color='primary' id="days-label">Days When Services Are Needed</InputLabel>
                            <Select label='Days When Services Are Needed' name='daysNeeded' color='primary' id="days-select" multiple
                                value={daysNeeded} onChange={handleDaysNeededChange} renderValue={(selected) => selected.join(', ')}>
                                {daysOfWeek.map((day) => (
                                    <MenuItem key={day} value={day}>
                                        <Checkbox size="small" name='daysNeeded' checked={daysNeeded.indexOf(day) > -1} />
                                        <ListItemText primary={day} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 mb-2">
                        <label style={{ fontSize: '0.9rem' }}>Additional information (care duration, conditions, preferences):</label>
                        <TextField multiline rows={3} size="small" label="Additional Information" color="primary" 
                            type="text" name="additionalNotes" fullWidth />
                    </div>
                </div>

                <div className="text-center">
                    <Button type="submit" className="btn mt-2" style={{ color: 'white', backgroundColor: '#1b8fc9', borderRadius: '5px',padding: '6px 24px'}}>
                        SEND
                    </Button>
                </div>
            </form>

            <Snackbar 
                open={openSnackbar} 
                autoHideDuration={6000} 
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
                    Your message has been sent successfully! We'll get back to you soon.
                </Alert>
            </Snackbar>
        </div>
    );
};

export default HomeCareForm;